import { apiService } from './apiService';
import ToastMe from '../components/ui/ToastMe';

export function updatePaymentService(data) {
    return apiService({
        method: 'POST',
        url: '/payment/updatePaymentGateway',
        data,
        onSuccess: (dispatch, res) => {
            ToastMe(res.data.message, 'success');
        },
        onFailure: () => {},
    });
}

export function getPaymentBySlugService(slug) {
    return apiService({
        method: 'GET',
        url: '/payment/' + slug,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getPaymentService(data) {
    return apiService({
        method: 'POST',
        url: '/payment/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getTablePaymentService() {
    return apiService({
        method: 'GET',
        url: '/front/payment',
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getWaffiPaymentService(data) {
    return apiService({
        method: 'POST',
        url: '/waafi-payment/payment',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getEdahabPaymentService(data) {
    return apiService({
        method: 'POST',
        url: '/edahab-payment/payment',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
export function getByTableIdEdahabPaymentService(id) {
    return apiService({
        method: 'GET',
        url: '/edahab-payment/payment/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getPremierPaymentService(data) {
    return apiService({
        method: 'POST',
        url: '/premier-payment/payment',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByTableIdPremierOrderService(id) {
    return apiService({
        method: 'GET',
        url: '/premier-payment/payment/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getRaamsPaymentService(data) {
    return apiService({
        method: 'POST',
        url: '/raams-payment/payment',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByTableIdRaamsPaymentService(id) {
    return apiService({
        method: 'GET',
        url: '/raams-payment/payment/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getRaamsPaymentVerifyService(uuid) {
    return apiService({
        method: 'GET',
        url: '/raams-payment/verify/' + uuid,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getRaamsGatewaysService() {
    return apiService({
        method: 'GET',
        url: '/raams-payment/gateways',
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function testRaamsConnectionService(data) {
    return apiService({
        method: 'POST',
        url: '/payment/test-raams',
        data,
        onSuccess: () => {},
        onFailure: () => {},
    });
}
